import _ from 'lodash'
import {Colors} from '@eitje/assets'
import {parseT} from '@eitje/bridge'
import {FONT_FAMILY} from '../constants'

const LABEL_STYLE = {
	background: Colors.lightBlueBackground,
	borderRadius: 4,
	fontSize: '12px',
	fontWeight: 500,
	fontFamily: FONT_FAMILY,
	padding: {left: 8, right: 8, top: 7, bottom: 7},
}

const LINE_STYLE = {borderColor: Colors.grey, strokeDashArray: 12, borderWidth: 2}

export const buildHorizontalLine = horizontalLine => {
	if (_.isEmpty(horizontalLine)) return {yaxis: []}

	const {t, y} = horizontalLine
	const label = {
		label: {
			text: parseT(t),
			style: LABEL_STYLE,
			borderColor: Colors.mediumBorder,
			offsetX: -8,
			offsetY: -12,
		},
	}

	return {
		yaxis: [
			{
				y,
				...LINE_STYLE,
				...(t && label),
			},
		],
	}
}
